import { styled } from 'styled-components';

export const PictureArea = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #000;
  display: flex;
  justify-content: center;
  margin-top: 90px;
`;
